import { Icon } from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const EmailFooter = ({ isDesktopPreview, getHowToUseLinks, useCase }) => {
  return (
    <StyledDiv
      className={`rewardEmailFooter d-flex align-items-center ${
        !isDesktopPreview ? "mobile" : ""
      }`}
    >
      <div className="email-footer-wrapper">
        <a
          href={getHowToUseLinks(useCase)}
          target="_blank"
          rel="noreferrer"
          className="mr-20"
        >
          <Typography.HelperText color="dark" shade="c200">
            How to use
          </Typography.HelperText>
        </a>
        <a
          className="ml-3"
          href="https://www.xoxoday.com/terms-of-use"
          target="_blank"
          rel="noreferrer"
        >
          <Typography.HelperText color="dark" shade="c200">
            Terms & Conditions
          </Typography.HelperText>
        </a>
      </div>
      <div className="d-flex align-items-center">
        <Typography.HelperText color="dark" shade="c200">
          Connect with us
        </Typography.HelperText>
        <Icon
          className="ml-8"
          size="16"
          iconName="PlumEmail"
          color="dark"
          shade="c100"
        />
        <Icon
          className="ml-8"
          size="16"
          iconName="PlumWhatsapp"
          color="dark"
          shade="c100"
        />
      </div>
    </StyledDiv>
  );
};

export default EmailFooter;
